'use strict';

import Loader from '../../_modules/loader/loader';
import OrderOverride from '../../_modules/order-override/order-override';
import FirstOrder from '../../_modules/first-order/first-order';

import { toaster } from '../../_assets/abbott/js/_material';

export default class SohModal {
	constructor() {
		let that = this;

		$('.js-back-to-regimen').on('click', function(){
			that.reviewRegimen();
		});
	}

	displayRegimenForm(){
		let $createRegimenForm = $('section.dashboard'),
			$firstOrderOverrideContainer = $('.form--order-override'),
			$firstOrderProductRow = $firstOrderOverrideContainer.find('.product-details__row'),
			loader = new Loader();

		loader.fadeIn();

		//hide and empty override fist order
		$firstOrderOverrideContainer.removeClass('show');
		$firstOrderProductRow.remove();

		$createRegimenForm.removeClass('hide');
		//TODO; put navigation back
		loader.fadeOut();
	};

	removeDisabled(){
		$('.disabled').each(function(){
			$(this).removeClass('disabled');
		});
	}

	displaySohModal(productDescs){

		this.removeDisabled();

		let isMobileDevice = Modernizr.mq('(max-width: 767px)'),
			that = this,
			option;

		$.fancybox.open('#soh-modal', {
			autoSize: true,
			closeBtn: false,
			fitToView: true,
			minWidth: isMobileDevice == true ? 250 : 768,
			padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
			type: 'inline',
			wrapCSS: 'modal',
			modal: true,
			afterShow: function(){
				$('.js-override-order').on('click', function (e){
					option = 'override';

					$.fancybox.close();
				});

				$('.js-review-regimen').on('click', function (e){

					option = 'review';

					$.fancybox.close();
				});
			},
			afterClose: function(){
				//need to call functions after closing to avoid to fire them too often

				setTimeout(function () {

					switch(option){
						case 'override': let overrideOrder = new OrderOverride();
										 overrideOrder.getCurrentStock();
										 that.toggleMultiStepNav(true);
										 that.scrollTo($('#main'));
										 break;
						case 'review': that.reviewRegimen();
						    		   break;
						default:
						    break;
					}
				}, 250);
			}
		});
	};

	populateSohModalList(data){
		let $list = $('#soh-modal__list'),
			fragment = $(document.createDocumentFragment());

		$list.empty();

	  	for (var i = 0, len = data.length; i < len; i++) {
			fragment.append(
		  		$('<li></li>')
					.text(data[i])
			);
	 	}

		$list.append(fragment);
	};

	displayWAPopup(msg) {
		this.removeDisabled();

		let isMobileDevice = Modernizr.mq('(max-width: 767px)'),
			that = this,
			option;

		$.fancybox.open('#soh-modal-wa', {
			autoSize: true,
			closeBtn: false,
			fitToView: true,
			minWidth: isMobileDevice == true ? 250 : 768,
			padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
			type: 'inline',
			wrapCSS: 'modal',
			modal: true,
			afterShow: function(){
				$(this.content).find("#soh-wa-list").html(msg);
				$(this.content).find('.js-review-regimen').on('click', function (e){
					option = 'review';
					$.fancybox.close();
				});
			},
			afterClose: function(){
				//need to call functions after closing to avoid to fire them too often
				setTimeout(function () {
					switch(option){
						case 'review': 
							that.reviewRegimen();
						    break;
						default:
						    break;
					}
				}, 250);
			}
		});
	}

	/* check whether selected products are in stock.
	** - if Out of Stock: display modal window
	** - else: regimen will be created
	*/
	_isInStock() {

		let that = this,
			loader = new Loader(),
			dataParams;

		let	firstOrder = new FirstOrder(),
			_firstOrderProducts = firstOrder.getFirstOrderProducts();

		if(typeof _firstOrderProducts === 'undefined')
			return true;

		loader.fadeIn();

		dataParams ={
			"PostCode": $('#postal_code').val(),
			"Products": _firstOrderProducts,
            "InstitutionId": $('#InstitutionId').val()
		};

		//var encodedParams = jQuery.param(dataParams);

		return $.ajax({
			url: '/api/products/checkStock',
			dataType: 'json',
			contentType: 'application/json; charset=utf-8',
			type: 'POST',
			data: JSON.stringify(dataParams),
			success: function (data) {

				if(!data.IsInStock){
					that.populateSohModalList(data.ProductsOutOfStock);
					that.displaySohModal();
				}
				let addressState = $('#administrative_area_level_1').val();
				if(data.IsInStock && addressState == "WA" && data.ProductsOutOfStockLocally.length > 0) {
					let prodListing = `${data.ProductsOutOfStockLocally.map(function(x){return `<li>${x.Description} (Available Stock in WA: ${x.Stock})</li>`}).join("")}`;
					that.displayWAPopup(prodListing);
				}

				loader.fadeOut();
			},
			error: function (error) {
				loader.fadeOut();
				toaster('Something went wrong.','error');
			}
		})
	};

	reviewRegimen(){
		let that = this;

		if($('.dashboard').is(':hidden'))
			that.displayRegimenForm();

		that.toggleMultiStepNav(false);
		that.scrollTo($('#regimen-products'));
	};

	scrollTo($el){
		let $offsetHeight = $('.header').height();

  	    $('html, body').animate({
  	        scrollTop: $( $el ).offset().top - $offsetHeight
  	    }, 1000);
	};

	toggleMultiStepNav(isOverride){
		let $backToregimen = $('.js-back-to-regimen'),
			isNotDesktop = Modernizr.mq('(max-width: 1023px)'),
			$others = $backToregimen.siblings('li:not(.back-to)');

		if(isOverride){
			$others.hide();
			$backToregimen.show();
		}
		else{
			$backToregimen.hide();

			//on mobile only those two elements need to be displayed
			if(isNotDesktop)
				$others = $others.filter('.show-summary__link, .current-page').show();

			$others.show();
		}
	};
}
